"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormTextarea", {
    enumerable: true,
    get: function() {
        return FormTextarea;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _useInputPadding = require("../useInputPadding");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormTextarea = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const [value, setValue] = (0, _react.useState)(typeof props.value === "string" ? props.value : "");
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    const { colors } = (0, _Theme.useTheme)();
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        showChrome: props.showChrome
    });
    const padding = (0, _useInputPadding.useInputPadding)();
    (0, _react.useEffect)(()=>{
        if (typeof props.value === "string") {
            setValue(props.value);
        }
    }, [
        props.value
    ]);
    var _props_id, _props_className;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("textarea", {
        ...props,
        ref: ref,
        id: (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id,
        "aria-describedby": hintId,
        onChange: (e)=>{
            setValue(e.target.value);
            if (props.onChange != null) {
                props.onChange(e);
            }
        },
        className: _style.default.dynamic([
            [
                "c39720379d2b285c",
                [
                    padding.shorthand,
                    props.variant === "lg" ? "24px" : "22px",
                    props.variant === "lg" ? "16px" : "14px",
                    value === "" ? colors.muted1 : "inherit",
                    padding.top,
                    padding.bottom,
                    colors.muted1
                ]
            ]
        ]) + " " + "".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(borderCss.className)
    }), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "c39720379d2b285c",
        dynamic: [
            padding.shorthand,
            props.variant === "lg" ? "24px" : "22px",
            props.variant === "lg" ? "16px" : "14px",
            value === "" ? colors.muted1 : "inherit",
            padding.top,
            padding.bottom,
            colors.muted1
        ]
    }, "textarea.__jsx-style-dynamic-selector{padding:".concat(padding.shorthand, ";line-height:").concat(props.variant === "lg" ? "24px" : "22px", ";-webkit-appearance:none;-moz-appearance:none;-ms-appearance:none;appearance:none;display:inline-block;cursor:pointer;float:none;outline:none;width:100%;font-size:").concat(props.variant === "lg" ? "16px" : "14px", ";color:").concat(value === "" ? colors.muted1 : "inherit", ";max-width:100%;resize:vertical;min-height:88px}textarea.__jsx-style-dynamic-selector:first-child{padding-top:").concat(padding.top, "}textarea.__jsx-style-dynamic-selector:last-child{padding-bottom:").concat(padding.bottom, "}textarea.__jsx-style-dynamic-selector::-webkit-input-placeholder{color:").concat(colors.muted1, "}textarea.__jsx-style-dynamic-selector:-moz-placeholder{color:").concat(colors.muted1, "}textarea.__jsx-style-dynamic-selector::-moz-placeholder{color:").concat(colors.muted1, "}textarea.__jsx-style-dynamic-selector:-ms-input-placeholder{color:").concat(colors.muted1, "}textarea.__jsx-style-dynamic-selector::-ms-input-placeholder{color:").concat(colors.muted1, "}textarea.__jsx-style-dynamic-selector::placeholder{color:").concat(colors.muted1, "}")), borderCss.styles);
});
FormTextarea.displayName = "FormTextarea";

//# sourceMappingURL=FormTextarea.js.map